import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "admin-card-title-row" }
const _hoisted_2 = {
  key: 0,
  class: "update-prompt-panel"
}
const _hoisted_3 = { class: "update-prompt-control-row" }
const _hoisted_4 = { class: "app-section-toggle update-prompt-toggle" }
const _hoisted_5 = {
  class: "update-campaign-chip",
  title: "Увеличивается при «Показать снова всем»"
}
const _hoisted_6 = { class: "update-prompt-message-wrap" }
const _hoisted_7 = { class: "update-prompt-message-hint" }
const _hoisted_8 = { class: "update-prompt-actions" }
const _hoisted_9 = {
  key: 1,
  class: "admin-hint"
}
const _hoisted_10 = {
  key: 0,
  class: "app-sections-list"
}
const _hoisted_11 = { class: "app-section-info" }
const _hoisted_12 = { class: "app-section-title-row" }
const _hoisted_13 = { class: "app-section-key" }
const _hoisted_14 = { class: "app-section-role" }
const _hoisted_15 = { class: "app-section-controls" }
const _hoisted_16 = { class: "app-section-toggle" }
const _hoisted_17 = {
  key: 1,
  class: "admin-hint"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageHeaderWithMenu = _resolveComponent("PageHeaderWithMenu")!
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_toggle = _resolveComponent("ion-toggle")!
  const _component_ion_textarea = _resolveComponent("ion-textarea")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_PageHeaderWithMenu, {
        title: "Разделы приложения",
        scrolled: _ctx.headerScrolled
      }, null, 8, ["scrolled"]),
      _createVNode(_component_ion_content, {
        class: _normalizeClass([_ctx.isMobile ? 'main-background' : 'liga-web-background']),
        fullscreen: true,
        onIonScroll: _ctx.onContentScroll
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_card, { class: "admin-card admin-card--glass" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_card_header, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    _createVNode(_component_ion_card_title, null, {
                      default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                        _createTextVNode("Обновление приложения", -1)
                      ]))]),
                      _: 1
                    }),
                    (_ctx.runtimeConfig)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: _normalizeClass(["update-status-badge", _ctx.runtimeConfig.updatePromptEnabled ? 'update-status-badge--on' : 'update-status-badge--off'])
                        }, _toDisplayString(_ctx.runtimeConfig.updatePromptEnabled ? 'Баннер включён' : 'Баннер выключен'), 3))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_card_content, null, {
                default: _withCtx(() => [
                  _cache[9] || (_cache[9] = _createElementVNode("p", { class: "admin-card-subtitle" }, " Когда сборки уже вышли во всех сторах (App Store, Google Play, AppGallery), включите флаг — пользователям со старой версией покажется предложение обновиться. Закрытие баннера запоминается до следующей «кампании» (повторный показ — кнопкой ниже). ", -1)),
                  (_ctx.runtimeConfig)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                          _createElementVNode("label", _hoisted_4, [
                            _cache[5] || (_cache[5] = _createElementVNode("span", null, "Показывать баннер обновления", -1)),
                            _createVNode(_component_ion_toggle, {
                              class: "update-prompt-ion-toggle",
                              checked: _ctx.runtimeConfig.updatePromptEnabled,
                              mode: "ios",
                              disabled: _ctx.savingRuntime,
                              onIonChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onUpdatePromptToggle($event)))
                            }, null, 8, ["checked", "disabled"])
                          ]),
                          _createElementVNode("span", _hoisted_5, " Кампания · " + _toDisplayString(_ctx.runtimeConfig.updatePromptVersion), 1)
                        ]),
                        _createElementVNode("div", _hoisted_6, [
                          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "update-prompt-message-label" }, "Текст сообщения", -1)),
                          _createVNode(_component_ion_textarea, {
                            class: "update-prompt-textarea",
                            modelValue: _ctx.runtimeConfig.updatePromptMessage,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.runtimeConfig.updatePromptMessage) = $event)),
                            "auto-grow": true,
                            rows: 3,
                            maxlength: "500",
                            placeholder: "Текст предложения обновить приложение"
                          }, null, 8, ["modelValue"]),
                          _createElementVNode("div", _hoisted_7, _toDisplayString((_ctx.runtimeConfig.updatePromptMessage || '').length) + "/500 ", 1)
                        ]),
                        _createElementVNode("div", _hoisted_8, [
                          _createVNode(_component_ion_button, {
                            size: "small",
                            fill: "solid",
                            shape: "round",
                            class: "update-prompt-btn update-prompt-btn--save",
                            disabled: _ctx.savingRuntime,
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.saveRuntimeConfig(false)))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_icon, {
                                slot: "start",
                                icon: _ctx.saveOutline
                              }, null, 8, ["icon"]),
                              _cache[7] || (_cache[7] = _createTextVNode(" Сохранить текст ", -1))
                            ]),
                            _: 1
                          }, 8, ["disabled"]),
                          _createVNode(_component_ion_button, {
                            size: "small",
                            fill: "outline",
                            shape: "round",
                            class: "update-prompt-btn update-prompt-btn--reshow",
                            disabled: _ctx.savingRuntime || !_ctx.runtimeConfig.updatePromptEnabled,
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.saveRuntimeConfig(true)))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_icon, {
                                slot: "start",
                                icon: _ctx.refreshOutline
                              }, null, 8, ["icon"]),
                              _cache[8] || (_cache[8] = _createTextVNode(" Показать снова всем ", -1))
                            ]),
                            _: 1
                          }, 8, ["disabled"])
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("p", _hoisted_9, "Настройки обновления не загружены."))
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_card, { class: "admin-card admin-card--glass" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_card_header, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_card_title, null, {
                    default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                      _createTextVNode("Доступ к разделам приложения", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_card_content, null, {
                default: _withCtx(() => [
                  _cache[12] || (_cache[12] = _createElementVNode("p", { class: "admin-card-subtitle" }, " Включите «Доступно всем» для публичных разделов или выберите роль, которая открывает закрытый раздел. ", -1)),
                  (_ctx.sections.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sections, (section) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: section.sectionKey,
                            class: "app-section-row"
                          }, [
                            _createElementVNode("div", _hoisted_11, [
                              _createElementVNode("div", _hoisted_12, [
                                _createElementVNode("h3", null, _toDisplayString(section.name), 1),
                                _createElementVNode("span", {
                                  class: _normalizeClass(['app-section-status', section.availableToAll ? 'app-section-status--public' : 'app-section-status--role'])
                                }, _toDisplayString(section.availableToAll ? 'Доступно всем' : 'По роли'), 3)
                              ]),
                              _createElementVNode("p", _hoisted_13, _toDisplayString(section.sectionKey), 1),
                              _createElementVNode("p", _hoisted_14, _toDisplayString(section.availableToAll ? 'Раздел виден всем пользователям' : _ctx.roleLabel(section.roleName)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_15, [
                              _createElementVNode("label", _hoisted_16, [
                                _cache[11] || (_cache[11] = _createElementVNode("span", null, "Доступно всем", -1)),
                                _createVNode(_component_ion_toggle, {
                                  modelValue: section.availableToAll,
                                  "onUpdate:modelValue": ($event: any) => ((section.availableToAll) = $event),
                                  mode: "ios",
                                  onIonChange: ($event: any) => (_ctx.saveSection(section))
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "onIonChange"])
                              ]),
                              _createVNode(_component_ion_item, {
                                lines: "none",
                                class: _normalizeClass(['app-section-role-select', { 'app-section-role-select--disabled': section.availableToAll }])
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_select, {
                                    label: "Роль доступа",
                                    "label-placement": "stacked",
                                    modelValue: section.roleName,
                                    "onUpdate:modelValue": ($event: any) => ((section.roleName) = $event),
                                    interface: "popover",
                                    "interface-options": _ctx.roleSelectPopoverOptions,
                                    mode: "ios",
                                    placeholder: "Выберите роль",
                                    disabled: section.availableToAll,
                                    onIonChange: ($event: any) => (_ctx.saveSection(section))
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allAuthorities, (a) => {
                                        return (_openBlock(), _createBlock(_component_ion_select_option, {
                                          key: a.name,
                                          value: a.name
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(a.description || a.name), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue", "onUpdate:modelValue", "interface-options", "disabled", "onIonChange"])
                                ]),
                                _: 2
                              }, 1032, ["class"])
                            ])
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("p", _hoisted_17, "Разделы приложения не загружены."))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["class", "onIonScroll"])
    ]),
    _: 1
  }))
}